module.exports = __webpack_public_path__ + "img/Contact-Us_Ann-154px.771ceb31.jpg";